import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { Link, useParams } from "react-router-dom";
import { fetchPlaceDetails } from "../../features/admin/placeSlice";
import InnerLoading from "../ui/InnerLoading";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, FreeMode } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import { FaEdit, FaStar } from "react-icons/fa";
import LocationPicker from "./models/LocationPicker";
import { fetchRoomsByStays } from "../../features/admin/roomSlice";
import Cookies from "js-cookie";
import { fetchOptionalServices } from "../../features/admin/additionalServiceSlice";

const PlaceDetails = () => {
    const { placeId } = useParams<{ placeId: string }>();
    const { t } = useTranslation();
    const userId = Cookies.get('userId');
    const dispatch = useDispatch<AppDispatch>();
    const { place, loading } = useSelector((state: RootState) => state.placeSlice);
    const { OptionalServices } = useSelector((state: RootState) => state.OptionalServiceSlice);
    const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

    useEffect(() => {
        if (placeId) {
            dispatch(fetchPlaceDetails({ placeId: parseInt(placeId) }));
            userId && dispatch(fetchRoomsByStays({ stayId: parseInt(placeId), userId }))
            userId && dispatch(fetchOptionalServices({ placeId: parseInt(placeId), userId }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [placeId, dispatch]);
    const calcPrice = (price: number, discount?: number) => {
        if (!discount || discount <= 0) return price;
        return price - (price * discount) / 100;
    };
    const isHall = place?.type === "Hall";
    const hasDiscount = (place?.discountPercentage ?? 0) > 0;

    const dayPrice = place?.price || 0;
    const nightPrice = place?.priceNight || 0;

    const finalDayPrice = calcPrice(dayPrice, place?.discountPercentage);
    const finalNightPrice = calcPrice(
        nightPrice,
        place?.discountNightPercentage
    );

    if (!place && loading) return <InnerLoading />;
    return (
        <div >
            <div className='bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6'>
                <h2 className='text-white text-lg font-semibold'>{t("place-details")}</h2>
            </div>
            <div className="w-full mx-auto bg-white p-4 py-10">

                <div className="space-y-4">
                    {/* الصورة الرئيسية */}
                    <Swiper
                        spaceBetween={10}
                        thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                        modules={[Thumbs]}
                        className="h-[250px] sm:h-[400px]  rounded-xl overflow-hidden"
                    >
                        {place?.images?.map((img, i) => (
                            <SwiperSlide key={i}>
                                <img src={img.url} alt={`slide-${i}`} className=" w-full h-full object-cover" />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* الصور المصغرة */}
                    <Swiper
                        onSwiper={setThumbsSwiper}
                        spaceBetween={10}
                        slidesPerView={5}
                        freeMode
                        watchSlidesProgress
                        modules={[FreeMode, Thumbs]}
                        className="h-20"
                    >
                        {place?.images?.map((img, i) => (
                            <SwiperSlide key={i}>
                                <img
                                    src={img.url}
                                    alt={`thumb-${i}`}
                                    className="w-full h-full object-cover rounded-md border hover:border-blue-500 transition"
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                <div className="mt-8 text-center space-y-2">
                    <h1 className="text-3xl font-bold text-gray-800">{place?.title}</h1>
                    {place?.type === "Stay" && place.subCategory.id !== 1 &&
                        <div className=" flex-center gap-2 text-blue-700  text-lg">
                            {place?.numberOfRooms && place?.numberOfRooms > 0 &&
                                <p>
                                    {place?.numberOfRooms === 1 ? t("a-room") : place?.numberOfRooms === 2 ? t("2-room") : place?.numberOfRooms + " " + t("a-rooms")}
                                </p>
                            }
                            {place?.numberOfHalls && place?.numberOfHalls > 0 ?
                                <p>
                                    + {place?.numberOfHalls} {t("palce-Hall")}
                                </p> : <p>{t("without-placeHall")}</p>
                            }
                        </div>
                    }


                    <p className="text-gray-500">{place?.location}</p>
                    <div className="flex-center w-full flex-col text-center gap-2">
                        {/* ===== القاعة ===== */}
                        {isHall ? (
                            <>
                                {/* السعر المسائي */}
                                {nightPrice > 0 && (
                                    <div>
                                        <h4 className="text-gray-600 mb-1">{t("evening-price")}</h4>
                                        <div className="flex-center gap-2">
                                        <span className="text-red-600 font-bold text-xl">
                                            {finalNightPrice.toFixed(2)} {place.currencyCode}
                                        </span>

                                        {place.discountNightPercentage && place.discountNightPercentage > 0 && (
                                            <span className="line-through text-gray-400 text-sm">
                                                {nightPrice.toFixed(2)} {place.currencyCode}
                                            </span>
                                        )}
                                    </div>
                                    </div>
                                    
                                )}

                                {/* السعر الصباحي */}
                                <div>
                                     <h4 className="text-gray-600 mb-1">{t("morning-price")}</h4>
                                    <div className="flex-center gap-2">
                                   
                                    <span className="text-red-600 font-bold text-xl">
                                        {finalDayPrice.toFixed(2)} {place.currencyCode}
                                    </span>

                                    {place.discountPercentage > 0 && (
                                        <span className="line-through text-gray-400 text-sm">
                                            {dayPrice.toFixed(2)} {place.currencyCode}
                                        </span>
                                    )}
                                </div>
                                </div>
                                
                            </>
                        ) : (
                            /* ===== الإقامة ===== */
                            <>
                                <span className="text-red-600 font-bold text-xl">
                                    {finalDayPrice.toFixed(2)} {place?.currencyCode}
                                </span>

                                {hasDiscount && (
                                    <span className="line-through text-gray-400 text-sm">
                                        {dayPrice.toFixed(2)} {place?.currencyCode}
                                    </span>
                                )}
                            </>
                        )}
                    </div>

                </div>

                <section className="mt-10 bg-white p-6 rounded-xl shadow-sm">
                    <h2 className="text-2xl font-semibold mb-4">{t("description")}</h2>
                    <p className="text-gray-700 leading-relaxed">{place?.details}</p>
                </section>

                <section className="mt-10 bg-white p-6 rounded-xl shadow-sm">
                    <h2 className="text-2xl font-semibold mb-4">{t("amenities")}</h2>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">

                        {place?.amenities?.length === 0 && <div className=" text-textSecond">{t("no-services")}</div>}
                        {place?.amenities?.map((amenity) => (
                            <div key={amenity.id} className="flex items-center gap-3 bg-gray-100 p-3 rounded-lg">
                                <img src={amenity.image} alt={amenity.title} className="w-6 h-6" />
                                <span className="text-sm text-gray-800">{amenity.title}</span>
                            </div>
                        ))}
                    </div>
                </section>
                {OptionalServices?.length > 0 && (
                    <div className="my-4 border p-3 rounded-lg">
                        <h4 className="font-semibold mb-2">{t("additional-services-added")}</h4>
                        <ul className="space-y-2">
                            {OptionalServices?.map((service) => (
                                <li
                                    key={service.id}
                                    className="border p-2 rounded bg-gray-50 flex justify-between items-center"
                                >
                                    <div>
                                        <p className="font-medium">{service.title}</p>
                                        <p className="text-sm text-gray-600">{service.details}</p>
                                    </div>
                                    <span className="text-primary font-bold">{service.price} {service.currencyCode}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <section className="mt-10 bg-white p-6 rounded-xl shadow-sm">
                    <h2 className="text-2xl font-semibold mb-4">{t("reviews")}</h2>
                    <div className="space-y-6">
                        {place?.reviews?.length === 0 && <div className=" text-textSecond">{t("no-reviews")}</div>}
                        {place?.reviews?.map((review) => (
                            <div key={review.id} className="border rounded-lg p-4">
                                <div className="flex items-center gap-3 mb-2">
                                    <img
                                        src={review.userImage ? review.userImage : "/asset/pp.svg"}
                                        alt={review.userName}
                                        className="w-10 h-10 rounded-full object-cover"
                                    />
                                    <div>
                                        <p className="font-semibold">{review.userName}</p>
                                        <p className="text-sm text-gray-400">
                                            {new Date(review.createAt).toLocaleDateString()}
                                        </p>
                                    </div>
                                </div>
                                <p className="text-yellow-500 mb-1  flex  items-center gap-1"><FaStar /> {review.rating}</p>
                                <p className="text-gray-700">{review.comment}</p>
                            </div>
                        ))}
                    </div>
                </section>
                {place?.latitude && place?.longitude && (
                    <LocationPicker onChange={() => ("")} latitude={place.latitude} longitude={place.longitude} />
                )}


            </div>
            <div className="flex justify-end w-full justify-self-end  pt-2">
                <Link to={`/dashboard/place-modal/${place?.id}`}
                    className="flex items-center gap-1 text-sm px-3 py-1 bg-yellow-100 text-yellow-800 hover:bg-yellow-200 rounded"
                >
                    <FaEdit /> {t("edit")}
                </Link>
            </div>
        </div>
    );
};

export default PlaceDetails;
